module.exports = __webpack_public_path__ + "ec24fc7cb1dc8100b80ccde9ae3b5c41.svg";